import Icon from 'app/components/Icon'
import Button from 'components/Buttons/Button'
import IconText from 'fragments/IconText'
import { Warning } from 'postcss'
import React, { InputHTMLAttributes, useContext, useEffect } from 'react'
import { ErrorGroupContext } from './ErrorGroup'
import { FormContext } from './Form'

interface Props extends InputHTMLAttributes<HTMLInputElement> {
    label?: string | any
    imagePreview?: boolean
    height?: string
}

function ImageInput(props: Props) {
    const { label, name = "file", imagePreview = false, height = "h-70px", ...rest } = props

    const { data, setData, errors, clearErrors } = useContext(FormContext)

    const { seterrors } = useContext(ErrorGroupContext);
    useEffect(() => {
        seterrors(e => ({ ...e, [name]: errors[name] }))
    }, [errors[name]])

    let fileList = data?.[name] as FileList;

    let preview = fileList ? Object.values(fileList)?.[0] : null;

    function prevent(e) {
        e.preventDefault();
        e.stopPropagation();
    }

    function dropFile(e) {
        prevent(e);
        let droppedFiles = e?.dataTransfer?.files as FileList;
        if (droppedFiles) {
            setData(`${name}`, droppedFiles);
        }

    };




    if (name.includes('[]'))
        throw new Error("Dont include [] in input name for multiple files, just add prop 'multiple | multiple={true}' ");

    let errs = Object.keys(errors)
        .filter(e => e.startsWith(`${name}`))
        .map(err => errors[err])
        .join(', ')

    return (
        <label className={`cursor-pointer relative flex flex-col h-full`}
            onDrag={prevent}
            onDragStart={prevent}
            onDragEnd={prevent}
            onDragOver={prevent}
            onDragEnter={prevent}
            onDragLeave={prevent}
            onDrop={dropFile}

        >

            <div>{label}</div>
            <input
                className="opacity-0 w-0 h-0 absolute"
                type="file"
                {...rest}
                name={`${name}[]`}
                onChange={e => { setData(name, e.target.files); clearErrors(name) }}
            />
            <div className={`flex items-center  flex-col bg-gray-darker  ${fileList?.length > 0 ?"rounded-t-md":"rounded-md"} shadow-card justify-center ${height} relative z-10 overflow-hidden`}>
                {
                    (imagePreview && preview && preview.type.startsWith("image")) &&
                    <img className="absolute top-0 left-0 h-full w-full object-cover object-center z-0" src={URL.createObjectURL(preview)} alt="Preview - Nahledovy obrazek | Serafin byliny" />
                }
                {/* <Button className="pointer-events-none mob:w-full text-left justify-start z-10" href="/noJS" onClick={e => { e.preventDefault(); }}><IconText icon="upload" text={(fileList?.length > 0) ? "Změnit soubor" : "Nahrát soubor"} /></Button> */}
                <div className=" text-12 mob:ml-0 mob:mt-8px z-10 bg-gray-darker/80  rounded px-6px">
                    {
                        (fileList?.length > 0)
                            ?
                            <div></div>

                            :
                            <div className='flex items-center justify-center'>
                                <Icon className={`text-green-539648`} name="plus" />
                            </div>
                    }
                </div>
            </div>
            {
                fileList?.length > 0 &&
                <div className='bg-gray-darker flex items-center justify-between px-12px py-6px rounded-b-md'>
                    <Icon className={`w-20px text-green-539648`} name="plus" />
                    <Icon className={`w-20px text-red`} name="bin" />
                </div>
            }
            <div className={`h-12px text-12 text-C86B28 ${errs ? "" : "opacity-0"}`}> {errs} </div>
        </label>
    )
}

export default ImageInput
